// hooks/useAuth.ts
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "@/store/features/auth/authSlice";
import { useLogoutMutation } from "@/store/features/auth/authAPI";

export const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [logoutMutation] = useLogoutMutation();

  const handleLogout = async () => {
    try {
      await logoutMutation().unwrap();
      dispatch(logout());
      navigate('/signin');
    } catch (error) {
      console.error('Logout failed:', error);
      // Force logout on client side even if API fails
      dispatch(logout());
      navigate('/signin');
    }
  };

  return { handleLogout };
};
